import { helpers } from "../../../../packages/helpers";
import { getAuthorData } from "./get-author-data";
import type { ApiAuthor, AuthorList } from "../../types";

const { getStringValue } = helpers.text;

const getAuthorListData = (
  authors: Array<ApiAuthor> = [],
  userId = ""
): AuthorList =>
  authors.length
    ? authors.reduce<AuthorList>((acc, author) => {
        const authorId = getStringValue(author?.id);
        const authorData = getAuthorData({ author, userId });

        return { ...acc, [authorId]: authorData };
      }, {})
    : {};

export { getAuthorListData };
